export const CAD = new Intl.NumberFormat("en-CA", {
  style: "currency",
  currency: "CAD",
  minimumFractionDigits: 2,
});

export function fmtCAD(n) {
  if (n == null || isNaN(n)) return "$0.00";
  return CAD.format(n);
}

export function fmtKm(n) {
  if (n == null || isNaN(n)) return "0 km";
  return `${Number(n).toLocaleString("en-CA", { maximumFractionDigits: 1 })} km`;
}

export function fmtDate(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-CA", { year: "numeric", month: "short", day: "2-digit" });
  } catch {
    return iso;
  }
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function downloadCSV(filename, rows) {
  const csv = rows.map((r) => r.map((c) => {
    if (c == null) return "";
    const s = String(c);
    if (s.includes(",") || s.includes("\"") || s.includes("\n")) {
      return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
  }).join(",")).join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

function dateForQIF(iso) {
  // Quicken QIF preferred: MM/DD/YYYY
  if (!iso || iso.length < 10) return "";
  const [y, m, d] = iso.split("-");
  return `${m}/${d}/${y}`;
}

function n(x) { return Number(x) || 0; }

export function buildQIF(trips, year) {
  const lines = ["!Type:Cash"];
  const inYear = (t) => (year ? t.date?.slice(0, 4) === String(year) : true);
  trips.filter(inYear).forEach((t) => {
    const date = dateForQIF(t.date);
    const destination = (t.destination || t.purpose || t.drug_name || "Medical trip").trim();
    const memo = [t.provider, t.purpose, t.notes].filter(Boolean).join(" — ");

    const items = [
      { amount: t.parking, label: "Parking", category: "Medical:Travel:Parking" },
      { amount: t.tolls, label: "Tolls", category: "Medical:Travel:Tolls" },
      { amount: t.meals, label: "Meals", category: "Medical:Travel:Meals" },
      { amount: t.accommodation, label: "Accommodation", category: "Medical:Travel:Accommodation" },
      { amount: t.other_amount, label: t.other_desc || "Other", category: "Medical:Travel:Other" },
      {
        amount: t.drug_amount,
        label: [t.drug_name, t.drug_pharmacy].filter(Boolean).join(" — ") || "Prescription",
        category: "Medical:Drugs",
      },
    ].filter((x) => n(x.amount) > 0);

    items.forEach((it) => {
      lines.push(`D${date}`);
      lines.push(`T-${n(it.amount).toFixed(2)}`);
      lines.push(`P${destination} — ${it.label}`);
      if (memo) lines.push(`M${memo}`);
      lines.push(`L${it.category}`);
      lines.push("^");
    });
  });
  // Quicken (esp. Windows) expects CRLF line endings in QIF files
  return lines.join("\r\n") + "\r\n";
}

export function downloadQIF(filename, trips, year) {
  const content = buildQIF(trips, year);
  const blob = new Blob([content], { type: "application/qif;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
